export const status = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  READY: 'READY',
  SUBMITTED: 'SUBMITTED',
  ERROR: 'ERROR',
};

export const analyticsMethods = {
  autofill_accepted: 'autofill_accepted',
  card_manual: 'card_manual',
  card_selected: 'card_selected',
};

export const defaultLanguage = 'en';

export const defaultShopperCurrency = {
  code: 'USD',
  decimalPlaces: '2',
  decimalSeparator: '.',
  exchangeRate: 1,
  isTransactional: true,
  symbol: '$',
  symbolLocation: 'left',
  thousandsSeparator: ',',
};

export const defaultPortalSettings = {
  contactPhone: {
    isVisible: false,
    isRequired: false,
  },
  newsletter: {
    isVisible: false,
    checked: false,
  },
  analytics: {
    isEnabled: false,
  },
  orderNotes: {
    isEnabled: false,
    customName: '',
    color: '#aaaaaa',
    mobileView: 'In Dropdown',
  },
  shippingProtection: {
    isEnabled: false,
    quote: 0,
  },
  customerSignature: {
    isEnabled: false,
    quote: 0,
  },
  termsAndConditions: {
    isEnabled: false,
    value: '',
  },
  theme: {
    mainColor: '#2d9cdb',
    textColor: '#ffffff',
  },
  coupon: {
    isEnabled: false,
    customName: '',
    color: '#aaaaaa',
    fontSize: 'medium',
    isBold: false,
    uppercase: false,
  },
  giftCard: {
    isEnabled: false,
  },
  scripts: [],
  isCodesAvailable: false,
};

export const paymentIdList = {
  UNDEFINED: 'undefined',
  CREDIT_CARD: 'credit-card',
  ACIMA: 'acima',
  AFFIRM: 'affirm',
  AFTERPAY: 'afterpay',
  APPLEPAY: 'applepay',
  GOOGLEPAY: 'googlepay',
  AMAZONPAY: 'amazonpay',
  PAYPAL: 'paypal',
  PAYLATER: 'paylater',
  KLARNA: 'klarna',
  CREDITKEY: 'creditkey',
  CREDOVA: 'credova',
  PAYTOMORROW: 'paytomorrow',
  PURCHASE: 'purchase',
  SEZZLE: 'sezzle',
  SNAPFINANCE: 'snapfinance',
  VENMO: 'venmo',
};

export const googlePayError = t => ({
  transactionState: 'ERROR',
  error: {
    intent: 'PAYMENT_AUTHORIZATION',
    message: t('payment_method.googlepay.error'),
    reason: 'PAYMENT_DATA_INVALID',
  },
});
